// extracted by mini-css-extract-plugin
export var aggregationCell = "_2x-t";
export var aggregationRow = "_2x-s";
export var borderlessSpinnerContainer = "_2x-3";
export var cardLayout = "_2x-6";
export var cardLayoutNoFooter = "_2x-a";
export var cardLayoutPageControl = "_2x-9";
export var cardLayoutWithFooter = "_2x-8";
export var closeIcon = "_2x-l";
export var columnHeaderSurface = "_2x-d";
export var columnHeaderSurfaceDragOverlay = "_2x-11";
export var columnHeaderSurfaceResizing = "_2x-y";
export var contextMenuAnchor = "_2x-1";
export var draggableColumnHeader = "_2x-z";
export var draggableColumnHeaderOverlay = "_2x-10";
export var expandIcon = "_2x-m";
export var expanded = "_2x-n";
export var filterBackIcon = "_2x-g";
export var filterButtonAnchor = "_2x-f";
export var filterDropdown = "_2x-o";
export var filterDropdownDivider = "_2x-j";
export var filterDropdownHeader = "_2x-r";
export var filterDropdownItem = "_2x-q";
export var filterDropdownModal = "_2x-p _2x-o";
export var filterItem = "_2x-e";
export var normalCellWithAdjustableBorder = "_2x-k";
export var pinButtonContainer = "_2x-u";
export var pinIcon = "_2x-v";
export var pinIconActive = "_2x-w";
export var spinner = "_2x-0";
export var spinnerContainer = "_2x-2";
export var subFilterArrowIcon = "_2x-h";
export var tableContainer = "_2x-4";
export var tableContentDraggingColumns = "_2x-c";
export var tableContentInner = "_2x-7";
export var tableContentInnerFill = "_2x-b";
export var tableContentWrapper = "_2x-5";
export var toolbarEnd = "_2x-i";
export var viewButtonContainer = "_2x-x";